
import React, {useState}  from 'react'
import { useNavigate } from 'react-router-dom'
import BuildMii from '../../build-mii/components/buildMii';
import DiscoveryMii from '../../discovery-notepad/components/discoveryMii';

const Home = props => {
  const navigate = useNavigate();
  const [hoveredBuildMiiPage, setHoveredBuildMiiPage] = useState(false);
  const [hoveredDiscoveryMiiPage, setDiscoveryMiiPage] = useState(false);

  const handleBuildMiiHoverToggle = () => {
    setHoveredBuildMiiPage(!hoveredBuildMiiPage)
  }

  const handleDiscoveryMiiMiiHoverToggle = () => {
    setDiscoveryMiiPage(!hoveredDiscoveryMiiPage)
  }
  // min-h-screen
  return (
      <div className="flex flex-col justify-center items-center min-h-full w-full bg-gray-200">
        <div className={`flex flex-row justify-center items-center w-full h-full `}>
          <BuildMii hoveredBuildMiiPage={hoveredBuildMiiPage} handleBuildMiiHoverToggle={handleBuildMiiHoverToggle}/>
        </div>
      {/* <div className={`flex flex-row justify-center items-center w-full h-1/2 ${hoveredDiscoveryMiiPage ? "bg-gray-500" : "bg-homepage-discoverymii-bg"}`}>
        <DiscoveryMii hoveredDiscoveryMiiPage={hoveredDiscoveryMiiPage} handleDiscoveryMiiMiiHoverToggle={handleDiscoveryMiiMiiHoverToggle}/>
      </div> */}
    </div>
  )
}

export default Home